import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Packaging24} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getWebshopMenu = ({webshopUrl = '', allowNewPackaging = false}): MenuItemConfig => {
  return {
    type: 'parent',
    label: 'webshop.title',
    multiplyLabel: true,
    icon: markRaw(Packaging24),
    children: [
      {
        type: 'internal',
        label: 'webshop.order',
        multiplyLabel: true,
        to: {
          name: 'packagings',
        },
      },
      {
        type: 'external',
        label: 'webshop.orderNewPackaging',
        multiplyLabel: true,
        href: webshopUrl,
        show: () => allowNewPackaging,
      },
    ],
  };
};
